module.exports = __webpack_public_path__ + "static/media/error.12843be2.png";